export enum SCWorkItemMode {
  SC_WM_INBOUND = 1,
  SC_WM_OUTBOUND = 2
}
